import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/fleet", label: "Fleet" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/reviews", label: "Reviews" },
  { to: "/contact", label: "Contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50" style={{ background: "rgba(11,12,14,0.85)", backdropFilter: "blur(18px)", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
      <div className="section-container flex items-center justify-between py-5">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="font-serif text-2xl tracking-wide text-[color:var(--lume-gold-light)]">LUME</span>
          <span className="text-[color:var(--lume-gold)]">·</span>
          <span className="font-serif text-2xl tracking-wide text-white">Enterprise</span>
        </Link>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-xs uppercase tracking-[0.22em] transition-colors ${isActive ? "text-[color:var(--lume-gold)]" : "text-slate-300 hover:text-white"}`
              }>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <Link to="/booking" className="hidden lg:inline-flex btn-gold" data-testid="nav-book-ride-btn">Book a Ride</Link>
        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Toggle menu">
          {open ? <X size={26}/> : <Menu size={26}/>}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-white/5 bg-[#0B0C0E]">
          <div className="section-container py-6 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)}
                data-testid={`nav-m-${l.label.toLowerCase()}`}
                className="text-sm uppercase tracking-[0.22em] text-slate-200">
                {l.label}
              </NavLink>
            ))}
            <Link to="/booking" onClick={() => setOpen(false)} className="btn-gold text-center" data-testid="nav-m-book-btn">Book a Ride</Link>
          </div>
        </div>
      )}
    </header>
  );
}
